// Arma, a partir de la lista plana que devuelve /api/comidas/menu, la estructura
// que usa el formulario de Solicitud de Comida.
export const buildMenu = (items = []) => {
    const menu = {
        Desayuno: { piezas: [], rellenos: [], bebidas: [] },
        Almuerzo: { platos: {}, contornos: [], bebidas: [] },
        Cena: { platos: {}, bebidas: [] },
        Refrigerio: { refrigerios: [] },
    };

    items.forEach(item => {
        const turno = menu[item.turno];
        if (!turno) return;
        if (item.tipo === 'plato' && turno.platos) {
            (turno.platos[item.categoria] = turno.platos[item.categoria] || []).push(item);
        } else if (item.tipo === 'contorno' && turno.contornos) {
            turno.contornos.push(item);
        } else if (item.tipo === 'bebida') {
            turno.bebidas.push(item);
        } else if (item.tipo === 'relleno' && turno.rellenos) {
            turno.rellenos.push(item);
        } else if (item.tipo === 'pieza' && turno.piezas) {
            turno.piezas.push(item);
        } else if (item.tipo === 'refrigerio' && turno.refrigerios) {
            turno.refrigerios.push(item);
        }
    });

    return menu;
};

export const etiquetaBebida = (bebida) =>
    bebida.descripcion ? `${bebida.nombre} (${bebida.descripcion})` : bebida.nombre;

// ─── Precios (USD) ────────────────────────────────────────────────────────────

// null/undefined/'' = el ítem no tiene precio cargado.
export const tienePrecio = (item) =>
    item != null && item.precio !== null && item.precio !== undefined && item.precio !== '';

// "$ 12,50"
export const formatoMonto = (valor) =>
    `$ ${Number(valor || 0).toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// ─── Refrigerios ──────────────────────────────────────────────────────────────

// '15:00' -> '3:00 p. m.'
export const hora12 = (hora) => {
    const [h, m] = String(hora || '').split(':').map(Number);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return hora || '';
    return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'a. m.' : 'p. m.'}`;
};

// "10 personas · 3:00 pm"
export const resumenRefrigerio = (r) => {
    if (!r) return '';
    const partes = [];
    if (r.personas) partes.push(`${r.personas} ${r.personas === 1 ? 'persona' : 'personas'}`);
    if (r.hora) partes.push(hora12(r.hora));
    return partes.join(' · ');
};
